export const ntucMenuItems = [
    {
        label: "menuitems.recon.text",
        access: ['admin', 'recon-user', 'recon-admin'],
        merchantType:"All",
        icon: `${require('../assets/images/menu_item/recon.svg')}`,
        iconActive: `${require('../assets/images/menu_item/recon_active.svg')}`,
        disabelBeforeOnboarding:true,
        subItems: [
            {
                label: "NTUC Uploads",
                link: '/reconciliation/ntuc/uploads',
                access: ['admin', 'recon-user', 'recon-admin'],
                merchantType: "All",
                icon: `${require('../assets/images/menu_item/data_ingestion.svg')}`,
                iconActive: `${require('../assets/images/menu_item/data_ingestion_active.svg')}`,
                subItems: []
            },
            {
                label: "NTUC Reports",
                link: '/reconciliation/ntuc/reports',
                access: ['admin', 'recon-user', 'recon-admin'],
                merchantType: "All",
                icon: `${require('../assets/images/menu_item/recon_reports.svg')}`,
                iconActive: `${require('../assets/images/menu_item/recon_reports_active.svg')}`,
                subItems: []
            },
            {
                label: "Create Reconciliation",
                link: '/reconciliation/ntuc/create',
                access: ['admin', 'recon-user', 'recon-admin'],
                merchantType: "All",
                icon: `${require('../assets/images/menu_item/recon.svg')}`,
                iconActive: `${require('../assets/images/menu_item/recon_active.svg')}`,
                subItems: []
            },
        ]
    }
];
